import type { PageStackTree } from '@lighthouse/core'
import { PAGE_STACK_DISPLAY_TYPE } from '@lighthouse/core'
import { nanoid } from '@lighthouse/tools'

export function getNode(id: string) {
    function recursion(tree?: PageStackTree[]): PageStackTree | undefined {
        if (!tree) {
            return
        }

        for (const stack of tree) {
            if (stack.stackId === id) {
                return stack
            }

            const res = recursion(stack.children)
            if (res) {
                return res
            }
        }
    }

    return (tree: PageStackTree) => {
        if (tree.stackId === id) {
            return tree
        }
        return recursion(tree.children)
    }
}

type StackFactory = Partial<PageStackTree> & {
    pageId: string
}

/**
 * 创建页面栈节点的工厂函数
 * 注意：运行时状态已拆分为独立的 atom，不再存储在 PageStackTree 中
 */
export function stackFactory({
    pageId,
    stackId = nanoid(),
    pageStackDisplayType = PAGE_STACK_DISPLAY_TYPE.page,
    ...rest
}: StackFactory): PageStackTree {
    return {
        stackId,
        pageId,
        pageStackDisplayType,
        ...rest
    }
}
